import React, { useEffect } from 'react'
import { TextFieldSeeker } from "@ui-seeker/core"
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { editUserId, isValidatingUser, userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"

import { object, string } from "yup"
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useValidatorSeeker } from "@hooks"

export default function UserNameField() {

	const { name, setNameInfo } = useAdminUsersInfo(userPayload.peek()?.user?.name, "name", "user")

	const { errorRegistry, isValid } = useValidatorSeeker(
		{ name: name },
		object({
			name: string().required('Must provide a user name')
				.test('checkUsername', 'User name is not available', async name => {
					isValidatingUser.value = true
					const isAvailable = await postSubmit(`${BACKEND_APIS.USER}/check-name`, {
						name: name,
						uid: userPayload.value?.clone ? null : editUserId.value
					})
					isValidatingUser.value = false
					return isAvailable?.validName
				})
		})
	)

	useEffect(() => {
		userErrorRegistry.value = { ...userErrorRegistry.peek(), name: isValid }
	}, [isValid])

	return <TextFieldSeeker
		label="Username"
		placeholder="Name of the user"
		value={name}
		onChange={e => setNameInfo(e.target.value)}
		error={errorRegistry?.name}
	/>
}